import { Directive, Input } from "@angular/core";
import { NzThMeasureDirective } from "ng-zorro-antd/table";

@Directive({
  selector: "th",
})
export class UiThMeasureDirective extends NzThMeasureDirective {
  @Input("uiWidth") public nzWidth: string | null = null;
  @Input("colspan") public colspan: string | number | null = null;
  @Input("colSpan") public colSpan: string | number | null = null;
  @Input("rowspan") public rowspan: string | number | null = null;
  @Input("rowSpan") public rowSpan: string | number | null = null;
}
